import { Doc } from '@bluebeam/carnivore';

class CarnivoreDoc {
  doc: Doc;

  constructor(doc: Doc) {
    this.doc = doc;
  }
}

export default CarnivoreDoc;
